import { view } from '@risingstack/react-easy-state'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import PropertyMap from '../../../components/property-map/property-map'
import GenericPageContainer from '../../../GenericPageElements/GenericPageContainer'
import request from '../../../helpers/request'
import endpoints from '../../../helpers/endpoints'
import Summary from '../../../components/ap-generics/components/GenericSummaryComponent'
import { CMOSLive } from '../../../components/ap-generics/components/evidence-tables/CMOSLive'
import { AddressBase } from '../../../components/ap-generics/components/evidence-tables/AddressBase'
import { ValuationOfficeAndCouncilTax } from '../../../components/ap-generics/components/evidence-tables/ValuationOfficeAndCouncilTax'
import { CMOSFormatted } from '../../../components/ap-generics/components/evidence-tables/CMOSFormatted'
import { MDS } from '../../../components/ap-generics/components/evidence-tables/MDS'
import { ConfirmModal } from '../../../components/ap-generics/components/modals/ConfirmModal.jsx'
import LinkedReferenceTable from '../../../components/linked-reference-table/LinkedReferenceTable.jsx'
import VoaHistoryTable from '../../../components/voa-history-table/VoaHistoryTable.jsx'

export default view(function NewSPIDsWorkflow() {
  const [summaryData, setSummaryData] = useState({})
  const [selectedMatches, setSelectedMatches] = useState({ abp: '', voa: '', ct: '' })
  const [confirmModal, setConfirmModal] = useState(false)
  const [cmosUserInput, setCmosUserInput] = useState({})
  const [meterUserInput, setMeterUserInput] = useState({})
  const [disabledByUserType, setDisabledByUserType] = useState(true)
  const [currentBrReference, setCurrentBrReference] = useState('')
  const [mdsData, setMdsData] = useState([])
  const [mdsDataReady, setMdsDataReady] = useState(true)
  const [customMDSPostcode, setCustomMDSPostcode] = useState('')
  const prefix = 'NEW_SPIDS'

  const [translations, setTranslations] = useState({})

  useEffect(() => {
    request(true).get('/translate?key=mosl_eligibility')
      .then(e => {
        setTranslations(e.data)
      })
  }, [])

  useEffect(() => {
    setSelectedMatches({ abp: '', voa: '', ct: '' })
  }, [summaryData.Core_SPID])

  const getMDSData = () => {
    if (!summaryData?.Core_SPID) return

    setMdsDataReady(false)
    request(true).get(endpoints.NEW_SPIDS_MDS_SPID, {
      doesCancel: true,
      params: {
        postcode: customMDSPostcode || summaryData.CF_Postcode || summaryData.CMOS_Postcode,
        cmos_uprn: summaryData.CMOS_UPRN,
        cmos_voa_no: summaryData.CMOS_VOA,
      }
    }).then(r => {
      setMdsData(r.data)
      setMdsDataReady(true)
    }).catch(e => {
      setMdsDataReady(true)
      console.log(e)
    })
  }

  return (
    <GenericPageContainer
      containerWidth={'95vw'}
      title="New SPIDs - Premises Workflow"
      titleIconClass={'fak fa-id-business-icon fa-2x colour-primary'}
      titleRight={
        <div>
          <Link className="navigate" to="/portal/new-spids">
            To Summary
          </Link>
        </div>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div style={{ display: 'grid', gap: 10 }}>
          <Summary
            translations={translations}
            summaryData={summaryData}
            setSummaryData={setSummaryData}
            workflow={true}
            setMdsData={setMdsData}
            setMdsDataReady={setMdsDataReady}
            getMDSData={getMDSData}
            setConfirmModal={setConfirmModal}
            prefix={prefix}
            setDisabledByUserType={setDisabledByUserType}
            disabledByUserType={disabledByUserType}
            customMDSPostcode={customMDSPostcode}
          />
        </div>

        <div style={{ display: 'grid', gridAutoColumns: '1fr', gridAutoFlow: 'column', gap: 10 }}>
          <CMOSLive translations={translations} summaryData={summaryData} selectedMatches={selectedMatches} setSelectedMatches={setSelectedMatches} prefix={prefix} disabledByUserType={disabledByUserType} />
          <AddressBase translations={translations} summaryData={summaryData} selectedMatches={selectedMatches} setSelectedMatches={setSelectedMatches} prefix={prefix} disabledByUserType={disabledByUserType} setUserInput={setCmosUserInput} />
          <ValuationOfficeAndCouncilTax translations={translations} summaryData={summaryData} selectedMatches={selectedMatches} setSelectedMatches={setSelectedMatches} prefix={prefix} disabledByUserType={disabledByUserType} setUserInput={setCmosUserInput} setCurrentBrReference={setCurrentBrReference} />
          <VoaHistoryTable voaReference={currentBrReference} translations={translations} prefix={prefix} />
          <CMOSFormatted translations={translations} summaryData={summaryData} setSummaryData={setSummaryData} workflow={true} selectedMatches={selectedMatches} prefix={prefix} disabledByUserType={disabledByUserType} userInput={cmosUserInput} setUserInput={setCmosUserInput} meterInput={meterUserInput} />
        </div>

        <div>
          <ConfirmModal confirmModal={confirmModal} setConfirmModal={setConfirmModal} prefix={prefix} summaryData={summaryData} setSummaryData={setSummaryData} cmosUserInput={cmosUserInput} meterUserInput={meterUserInput} />
        </div>

        <LinkedReferenceTable summaryData={summaryData} translations={translations} prefix={prefix} />
        <MDS data={mdsData} MDSDataReady={mdsDataReady} getData={getMDSData} customPostcode={customMDSPostcode} setCustomPostcode={setCustomMDSPostcode} style={{ fontSize: '14px' }} classes={'squish'} SPID={summaryData?.Core_SPID} />

        <div style={{ minHeight: '40vh', marginBottom: '10em' }}>
          <PropertyMap
            translations={translations}
            eastingNorthing={summaryData && summaryData.CMOS_UPRN_GISX && summaryData.CMOS_UPRN_GISY && [parseInt(summaryData.CMOS_UPRN_GISX), parseInt(summaryData.CMOS_UPRN_GISY)]}
            address={summaryData['CMOS_Address_Single_Line']}
            uprnEastingNorthing={summaryData && summaryData.Matched_UPRN_GISX && summaryData.Matched_UPRN_GISY ? [parseInt(summaryData.Matched_UPRN_GISX), parseInt(summaryData.Matched_UPRN_GISY)] : null}
            displayExtraPins={true}
            matchedUprnText={true}
          />
        </div>
      </div>
    </GenericPageContainer>
  )
})
